import { Flex, Skeleton } from '@iheartjane/reefer';

import styles from './bagTransferModalSkeleton.module.css';

export function BagTransferModalSkeleton() {
  return (
    <Skeleton animate className={styles['container']}>
      <Flex justifyContent="center">
        <Skeleton.Bone className={styles['modalHeader']} />
      </Flex>
      <Flex flexDirection="column" className={styles['details']}>
        <Skeleton.Bone className={styles['detailsText']} />
        <Skeleton.Bone className={styles['detailsText']} />
        <Skeleton.Bone className={styles['detailsText']} />
      </Flex>
      <Flex justifyContent="space-between">
        <Skeleton.Bone className={styles['bagDetail']} />
        <Skeleton.Bone className={styles['bagDetail']} />
      </Flex>
      <Flex flexDirection="column" className={styles['bagItemsContainer']}>
        {Array.from({ length: 3 }).map((_, i) => {
          return (
            <Flex key={i} className={styles['bagItem']}>
              <Flex>
                <Skeleton.Bone className={styles['bagItemImage']} />
              </Flex>
              <Flex
                flexDirection="column"
                className={styles['bagItemProductDetails']}
              >
                <Skeleton.Bone className={styles['bagItemName']} />
                <Skeleton.Bone className={styles['bagItemBrand']} />
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    </Skeleton>
  );
}
